import styled from '@emotion/styled';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import colors from 'config/theme/colors';
import Icon from 'ui/base/icons/loading-icon.svg';

const FleetbackIcon = styled(Icon)`
  @keyframes flash {
    from {
      fill: ${colors['@splash-bg']};
    }
    49.99% {
      fill: ${colors['@splash-bg']};
    }
    50.00% {
      fill: ${colors['@primary-color']};
    }
    99.99% {
      fill: ${colors['@primary-color']};
    }
    to {
      fill: ${colors['@splash-bg']};
    }
  }

  width: 150px;
  height: 150px;
  path {
    fill: ${colors['@splash-bg']};

    &:first-of-type {
      animation-name: flash;
      animation-duration: 1000ms;
      animation-iteration-count: infinite;
      animation-timing-function: linear;
    }
  }
`;

const Wrapper = styled.div`
  height: calc(100vh - 60px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  > div {
    font-size: 16px;
    color: ${colors['@primary-color']};
    width: 150px;

    > div {
      width: 79.13%;
      text-align: center;
    }
  }
`;

const FleetbackSplash = () => (
  <Wrapper data-cy="splash-screen">
    <FleetbackIcon />
    <div>
      <div>
        <FormattedMessage id="loading" defaultMessage="Loading ..." />
      </div>
    </div>
  </Wrapper>
);

export default FleetbackSplash;
